module.exports = __webpack_public_path__ + "img/allottee1_7-8-2021.40ddc20c.jpg";